import React from 'react';
import '../components/grammar-page.css';
import { FaLightbulb, FaBookOpen } from 'react-icons/fa';

const UsedToExplanation = () => {
  return (
    <div className="grammar-explanation">

      <h2><FaBookOpen /> Grammar Explanation</h2>

      <p>
        The expressions <strong>used to</strong>, <strong>be used to</strong>, and <strong>get used to</strong> look similar, 
        but they have different meanings and grammatical structures. 
        They help us talk about past habits, familiarity, and the process of becoming accustomed to something.
      </p>
      <hr />

      <h3><FaLightbulb /> Used to + base verb</h3>
      <p>
        We use <strong>used to</strong> to talk about past habits or states that were true in the past 
        but are not true anymore.
      </p>
      <ul>
        <li>I <strong>used to live</strong> in London. (I don’t live there now.)</li>
        <li>She <strong>used to smoke</strong>, but she quit. (She doesn’t smoke now.)</li>
        <li>There <strong>used to be</strong> a cinema here. (It’s gone now.)</li>
      </ul>

      <h3><FaLightbulb /> Not anymore / No longer</h3>
      <p>
        We often use <strong>not anymore</strong> (informal) or <strong>no longer</strong> (formal) 
        to show that something has changed.
      </p>
      <ul>
        <li>I play tennis a lot, but I <strong>don’t play anymore</strong>.</li>
        <li>He is <strong>no longer</strong> interested in football.</li>
        <li>We <strong>don’t eat meat anymore</strong>.</li>
      </ul>

      <h3><FaLightbulb /> Be used to + noun / gerund (-ing)</h3>
      <p>
        <strong>Be used to</strong> means “to be familiar with” or “to be comfortable with” something. 
        It describes a situation that is normal for someone.
      </p>
      <ul>
        <li>I am <strong>used to waking up</strong> early. (It feels normal.)</li>
        <li>She is <strong>used to the cold weather</strong>.</li>
        <li>They are <strong>used to working</strong> long hours.</li>
      </ul>

      <h3><FaLightbulb /> Get used to + noun / gerund (-ing)</h3>
      <p>
        <strong>Get used to</strong> describes the process of becoming familiar with something. 
        It refers to change over time.
      </p>
      <ul>
        <li>I am <strong>getting used to driving</strong> on the left.</li>
        <li>He can’t <strong>get used to</strong> the noise in the city.</li>
        <li>We will <strong>get used to working</strong> remotely.</li>
      </ul>

      <h3>Notes</h3>
      <ul>
        <li><strong>Used to + verb</strong> is only for the past. It describes something that isn’t true anymore.</li>
        <li><strong>Be used to</strong> and <strong>get used to</strong> are followed by a <strong>noun</strong> or an <strong>-ing form</strong>.</li>
        <li><strong>Be used to</strong> = it is normal now; <strong>get used to</strong> = the process of becoming comfortable.</li>
      </ul>

    </div>
  );
};

export default UsedToExplanation;
